import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StorageFirebaseService {

  constructor(private storage: AngularFireStorage) { }

  public obtenerRutaArchivo(ruta: string): Observable<string | null> {
    return this.storage.ref(ruta).getDownloadURL().pipe(
      catchError(err => {
        console.error("Ocurrio un error al obtener la ruta: ", err);
        return of(null); 
      }),
    );
  }

}
